<template>
	<v-container>
		<v-row>
			<v-col cols="12">
				<v-card :loading="loading" flat>
					<v-card-title>
						{{
							view
								? "Visualizar contrato"
								: id
									? "Editar contrato"
									: "Cadastrar contrato"
						}}
					</v-card-title>
					<v-col class="pl-10 pr-10 pb-5" cols="12" md="12">
						<v-row>
							<v-col cols="12" md="4">
								<v-select v-model="contract.CODGRP" :items="groups" item-text="DESGRP" item-value="CODGRP" label="Grupo"
									class="required" clearable :disabled="!canEdit()" :loading="loadingGroup"></v-select>
							</v-col>
							<v-col cols="12" md="4">
								<v-select v-model="contract.GERCOPARE" :items="corporateAreas" item-text="DESAREA"
									item-value="GERCOPARE" label="Área Corporativa" :disabled="!canEdit()" :loading="loadingCorporateArea"
									clearable @change="updateCorporateArea()"></v-select>
							</v-col>
							<v-col cols="12" md="4">
								<v-select v-model="contract.CODEMP" :items="companies" item-text="DESEMP" item-value="CODEMP"
									label="Empresa" :disabled="disableCompany || !canEdit()" :loading="loadingCompany" clearable
									@change="getUnits(true)"></v-select>
							</v-col>
							<v-col cols="12" md="4">
								<v-select v-model="contract.CODUNI" :items="units" item-text="DESUNI" item-value="CODUNI"
									label="Unidade" :disabled="disableUnit || !canEdit()" :loading="loadingUnit" clearable
									@change="getAreas(true)"></v-select>
							</v-col>
							<v-col cols="12" md="4">
								<v-select v-model="contract.CODARE" :items="areas" item-text="DESARE" item-value="CODARE" label="Área"
									:disabled="disableArea || !canEdit()" clearable :loading="loadingArea"
									no-data-text="Nenhuma área encontrada."></v-select>
							</v-col>
							<v-col cols="12" md="4">
								<v-select v-model="contract.TIPCON" :items="types" label="Tipo" clearable
									:disabled="!canEdit()"></v-select>
							</v-col>
							<v-col cols="12" md="12">
								<v-text-field v-model="contract.TITCON" label="Título" class="required"
									:disabled="!canEdit()"></v-text-field>
							</v-col>
							<v-col cols="12" md="12">
								<v-textarea :counter="true" v-model="contract.DESCON" label="Descrição" class="required"
									:disabled="!canEdit()"></v-textarea>
							</v-col>
							<v-col cols="12" md="6">
								<v-text-field v-model="formattedDate" label="Data de Cadastro" class="required" type="date"
									:disabled="!canEdit()"></v-text-field>
							</v-col>
							<v-col cols="12" md="6">
								<v-text-field v-model="contract.VALCON" label="Validade" type="number"
									:disabled="!canEdit()"></v-text-field>
							</v-col>
							<v-col cols="12" md="6">
								<v-text-field v-model="contract.CNPJ_PARTE" :disabled="!canEdit()" v-mask="'##.###.###/####-##'"
									label="CNPJ da Parte Envolvida" />
							</v-col>
							<v-col cols="12" md="6">
								<v-text-field v-model="contract.RAZAO_PARTE" :disabled="!canEdit()"
									label="Razão Social da Parte Envolvida" />
							</v-col>
							<v-col cols="12" md="6">
								<v-select v-model="contract.SITUACAO" :disabled="!canEdit()" :items="situacoesDisponiveis" label="Situação do Contrato" />
							</v-col>
							<v-col cols="12" md="6">
								<v-text-field v-model="contract.DT_ULT_ALT_SIT" label="Data/Hora Última Alteração de Situação"
									:disabled="true" />
							</v-col>
							<v-col cols="12">
								<h3>Anexos do Contrato</h3>
								<v-file-input label="Adicionar Anexos" multiple show-size counter chips @change="onFileSelect"
									accept=".pdf,.doc,.docx" :loading="loadingAttachment" :disabled="loadingAttachment || !canEdit()" />
								<v-list>
									<v-list-item v-for="attachment in attachments" :key="attachment.GERCONANEXO">
										<v-list-item-content>
											<v-list-item-title>{{ attachment.NOME_ARQUIVO }}</v-list-item-title>
										</v-list-item-content>
										<v-list-item-action>
											<v-btn icon @click="downloadAttachment(attachment.GERCONANEXO)">
												<v-icon color="primary">mdi-download</v-icon>
											</v-btn>
										</v-list-item-action>
										<v-list-item-action>
											<v-btn v-show="canEdit()" icon @click="deleteAttachment(attachment.GERCONANEXO)">
												<v-icon color="red">mdi-delete</v-icon>
											</v-btn>
										</v-list-item-action>
									</v-list-item>
								</v-list>
							</v-col>
							<v-col v-if="id" cols="12">
								<h3>Movimentações do Contrato</h3>
								<v-textarea v-model="novaMovimentacao" ref="novaMovimentacaoInput" label="Nova Movimentação"
									:counter="2000" :rules="[
										v => (v && v.length >= 10) || 'Mínimo de 10 caracteres',
										v => (v && v.length <= 2000) || 'Máximo de 2000 caracteres'
									]" :maxlength="2000" :rows="3" />
								<v-btn color="primary" @click="addMovement(novaMovimentacao)" :loading="loadingMovement"
									:disabled="!canEdit() || loadingMovement || !novaMovimentacao || novaMovimentacao.length < 10 || novaMovimentacao.length > 2000">
									Adicionar Movimentação
								</v-btn>
							</v-col>
						</v-row>
						<v-row class="mt-5">
							<v-container>
								<v-btn color="primary" depressed tile class="mr-4" @click="save" :disabled="loading"
									v-show="canEdit()">Salvar</v-btn>
								<v-btn color="primary" text class="mr-4" @click="$router.go(-1)" :disabled="loading">
									Voltar
								</v-btn>
							</v-container>
						</v-row>
						<h3 v-if="id" class="mt-5">Histórico</h3>
						<v-simple-table v-if="id">
							<thead>
								<tr>
									<th>Responsável</th>
									<th>Descrição</th>
									<th>Data</th>
									<th>Hora</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="mov in movements" :key="mov.GERCONMOV">
									<td>{{ mov.NOMUSU }}</td>
									<td>{{ mov.TEXTO_MOVIMENTACAO }}</td>
									<td>{{ formatDate(mov.DATA_MOVIMENTACAO) }}</td>
									<td>{{ mov.HORA_MOVIMENTACAO }}</td>
								</tr>
							</tbody>
						</v-simple-table>
						<v-alert v-if="!id" type="info" class="mt-5">Salve este contrato para adicionar
							movimentações</v-alert>
					</v-col>
				</v-card>
			</v-col>
		</v-row>
		<template>
			<Dialog ref="confirm" />
		</template>
	</v-container>
</template>

<script>
import CompanyGroupService from "../../app/Services/CompanyGroupService";

import Dialog from "../misc/Dialog";
import ContractsService from "../../app/Services/ContractsService";
import CompanyService from "../../app/Services/CompanyService";
import AreaService from "../../app/Services/AreaService";
import CorporateAreaService from "../../app/Services/CorporateAreaService";
import UnitService from "../../app/Services/UnitService";
import UserService from "../../app/Services/UserService";
import { ContractTypeEnum } from "./enums/ContractTypeEnum";
import { formatDate, formatDateTime } from "../../plugins/utils";

const companyGroupService = CompanyGroupService.build();
const contractsService = ContractsService.build();
const companyService = CompanyService.build();
const areaService = AreaService.build();
const corporateAreaService = CorporateAreaService.build();
const unitService = UnitService.build();
const userService = UserService.build();

export default {
	name: "ContractsForm",
	components: { Dialog },
	data: () => ({
		id: null,
		fileRules: [],
		view: false,
		initialSituacao: null,
		groups: [],
		companies: [],
		areas: [],
		corporateAreas: [],
		units: [],
		types: Object.entries(ContractTypeEnum).map(([value, key]) => ({
			text: key,
			value: value,
		})),
		contract: {
			GERCON: 0,
			CODGRP: 0,
			CODEMP: 0,
			CODUNI: 0,
			CODARE: 0,
			GERCOPARE: 0,
			TITCON: "",
			DESCON: "",
			VALCON: "",
			FILE_NAME: "",
			FILE: "",
			FILE_TYPE: "",
			TIPCON: null,
			CNPJ_PARTE: "",
			RAZAO_PARTE: "",
			SITUACAO: 1,
			DT_ULT_ALT_SIT: "",
			DATA_CADASTRO: "",
		},
		attachmentsTemp: [],
		loadingGroup: true,
		loading: false,
		loadingCompany: false,
		loadingUnit: false,
		loadingArea: false,
		loadingPrograma: false,
		loadingCorporateArea: false,
		disableCompany: false,
		disableUnit: false,
		disableArea: false,
		disableProgramas: false,
		fileBase64: "",
		programas: [],
		programasModel: [],
		loadingType: false,
		disableType: false,
		attachments: [],
		movements: [],
		novaMovimentacao: "",
		loadingAttachment: false,
		loadingMovement: false,
		situacoes: [
			{ text: "Cadastrado", value: 1 },
			{ text: "Em Avaliação", value: 2 },
			{ text: "Aguardando Assinatura", value: 3 },
			{ text: "Retornado", value: 4 },
			{ text: "Versão Final Assinado", value: 5 },
			{ text: "Concluído", value: 6 },
		],
	}),
	mounted() {
		const { id, view } = this.$route.params;
		this.userData = JSON.parse(localStorage.getItem("user"));

		if (id) {
			this.id = id;
		} else {
			const today = new Date().toISOString().split("T")[0];
			this.contract.DATA_CADASTRO = today;
		}

		if (view) {
			this.view = view;
		}

		this.fetch();
	},
	methods: {
		canEdit() {
			if (!this.id) {
				return true;
			}

			if (this.isUserEvaluator && [2, 3].includes(this.initialSituacao)) {
				return true;
			} else if (this.userData.user.CODUSU === this.contract.USUCAD && [1, 4, 5].includes(this.initialSituacao)) {
				return true;
			}

			return false;
		},

		toast(type, message, icon = "mdi-check") {
			this.$toasted.show(message, {
				type: type,
				icon: icon,
			});
		},
		save() {
			if (!this.contract.CODGRP) {
				this.toast("warning", "Informe o grupo do contrato para continuar");
				return;
			}

			if (!this.contract.TITCON) {
				this.toast("warning", "Informe o título do contrato para continuar");
				return;
			}

			if (!this.contract.DESCON) {
				this.toast("warning", "Informe a descrição do contrato para continuar");
				return;
			}

			if (!this.contract.DATA_CADASTRO) {
				this.toast(
					"warning",
					"Informe a data de cadastro do contrato para continuar"
				);
				return;
			}

			this.loading = true;

			const payload = { ...this.contract };

			if (this.attachmentsTemp.length > 0) {
				payload.attachments = this.attachmentsTemp.map(a => ({
					NOME_ARQUIVO: a.name,
					ARQUIVO: a.file,
					DT_UPLOAD: new Date().toISOString(),
					USU_RESP: this.userData.user.CODUSU,
				}));
			}


			const rest = this.id
				? contractsService.update({ id: this.id, ...payload })
				: contractsService.create(payload);

			rest
				.then((response) => {
					if (!response) {
						return;
					}

					this.toast(
						"success",
						this.id
							? "Contrato atualizado com sucesso!"
							: "Contrato adicionado com sucesso!"
					);
					this.loading = false;

					if (!this.isInModal) {
						this.$router.push("/contracts/list");
					} else {
						this.$emit("saved", true);
					}
				})
				.catch((res) => {
					if (res.response.data) {
						const data = JSON.parse(res.response.data);

						this.toast("erro", data.message);
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getGroup() {
			this.loadingGroup = true;

			companyGroupService.search("").then((response) => {
				this.groups = response;
				this.loadingGroup = false;
			});
		},
		getCompanies() {
			this.loadingCompany = true;
			return companyService.search({}).then((response) => {
				this.companies = response;
				this.loadingCompany = false;
			});
		},
		getUnits(change) {
			const search = {};

			this.units = [];
			this.areas = [];
			this.loadingUnit = true;

			if (change) {
				this.contract.CODUNI = "";
				this.contract.CODARE = "";
			}

			if (this.contract.CODEMP) {
				search.company = this.contract.CODEMP;
			}

			return unitService.search(search).then((response) => {
				this.units = response;
				this.loadingUnit = false;
			});
		},
		getAreas(change) {
			const search = {};

			this.areas = [];
			this.loadingArea = true;

			if (change) {
				this.contract.CODARE = "";
			}

			if (this.contract.CODEMP) {
				search.company = this.contract.CODEMP;
			}

			if (this.contract.CODUNI) {
				search.unit = this.contract.CODUNI;
			}

			areaService.search(search).then((response) => {
				this.areas = response;
				this.loadingArea = false;
			});
		},
		getCorporateArea(change) {
			const search = {};

			this.corporateAreas = [];
			this.loadingCorporateArea = true;

			if (change) {
				this.contract.CODARE = "";
			}

			corporateAreaService.search(search).then((response) => {
				this.corporateAreas = response;
				this.loadingCorporateArea = false;
			});
		},
		getUsers() {
			this.loadingUser = true;
			return userService.usersByKey().then((response) => {
				this.users = response;
				this.loadingUser = false;
			});
		},
		updateCorporateArea() {
			if (parseInt(this.contract.GERCOPARE) > 0) {
				this.contract.CODEMP = 0;
				this.contract.CODUNI = 0;
				this.contract.CODARE = 0;

				this.disableCompany = true;
				this.disableUnit = true;
				this.disableArea = true;
			} else {
				this.disableCompany = false;
				this.disableUnit = false;
				this.disableArea = false;
			}
		},
		async fetch() {
			const funcs = [];

			if (this.id) {
				funcs.push(this.getContrato());
				this.attachments = await contractsService.getAttachments(this.id);
				this.movements = await contractsService.getMovements(this.id);
			}

			funcs.push(this.getGroup());
			funcs.push(this.getCompanies());
			funcs.push(this.getUsers());
			funcs.push(this.getCorporateArea());

			Promise.all(funcs)
				.then(() => {
					if (this.id) {
						this.getUnits(false);
						this.getAreas();
						this.updateCorporateArea();
					}
				})
				.finally(() => { });
		},
		async onFileSelect(files) {
			if (!files || files.length === 0) {
				this.attachmentsTemp = [];
				return;
			}

			this.attachmentsTemp = [];

			for (const file of files) {
				const base64 = await this.toBase64(file);
				this.attachmentsTemp.push({
					file: base64,
					name: file.name,
					type: file.type
				});
			}
		},
		toBase64(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = () => resolve(reader.result);
				reader.onerror = (error) => reject(error);
				reader.readAsDataURL(file);
			});
		},
		async getContrato() {
			this.loading = true;

			return contractsService.read({ id: this.id }).then((response) => {
				this.contract = response.contract;
				this.isUserEvaluator = response.isUserEvaluator;
				this.initialSituacao = parseInt(this.contract.SITUACAO);
				this.contract.DT_ULT_ALT_SIT = formatDateTime(this.contract.DT_ULT_ALT_SIT);
				this.loading = false;
			});
		},
		async downloadAttachment(id) {
			try {
				this.$root.$Loading.show("Fazendo download...");

				const response = await contractsService.downloadAttachment(id);

				const base64Data = response.file;
				const fileName = response.name;

				const byteCharacters = atob(base64Data.split(',')[1] || base64Data);
				const byteNumbers = new Array(byteCharacters.length);
				for (let i = 0; i < byteCharacters.length; i++) {
					byteNumbers[i] = byteCharacters.charCodeAt(i);
				}
				const byteArray = new Uint8Array(byteNumbers);

				const blob = new Blob([byteArray]);
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = fileName;
				link.click();

				URL.revokeObjectURL(link.href);

				this.$root.$Loading.hide();
			} catch (error) {
				this.toast("error", "Não foi possível baixar o anexo.");
				this.$root.$Loading.hide();
			}
		},
		async deleteAttachment(id) {
			this.$root.$Loading.show("Excluindo anexo...");
			await contractsService.deleteAttachment(id);
			this.attachments = await contractsService.getAttachments(this.id);
			this.$root.$Loading.hide();
		},
		async addMovement(texto) {
			this.loadingMovement = true;
			try {
				const data = {
					GERCON: this.id,
					SEQUENCIA: this.movements.length + 1,
					TEXTO_MOVIMENTACAO: texto,
					DATA_MOVIMENTACAO: new Date().toISOString().split('T')[0],
					HORA_MOVIMENTACAO: new Date().toTimeString().split(' ')[0],
					USU_RESP: this.userData.user.CODUSU,
				};
				await contractsService.addMovement(data);
				this.movements = await contractsService.getMovements(this.id);
				this.novaMovimentacao = "";
				this.$refs.novaMovimentacaoInput.resetValidation();
			} finally {
				this.loadingMovement = false;
			}
		},
		formatDate,
	},
	computed: {
		situacoesDisponiveis() {
			if (this.isUserEvaluator) return this.situacoes;

			const allowed = new Set([1, 2, 6]);
			const list = this.situacoes.filter(s => allowed.has(s.value));

			const current = parseInt(this.contract.SITUACAO);
			if (current && !allowed.has(current)) {
				const currentItem = this.situacoes.find(s => s.value === current);
				if (currentItem) list.unshift(currentItem);
			}

			return list;
		},
		formattedDate: {
			get() {
				return this.contract.DATA_CADASTRO
					? this.contract.DATA_CADASTRO.split("T")[0]
					: "";
			},
			set(value) {
				this.contract.DATA_CADASTRO = value;
			},
		},
	},
};
</script>
